<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("shipping") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-6 col-5 text-right">
					<base-button
							@click="handlePlatformSyncInit()"
							v-if="lock"
							>Order Sync</base-button
						>
						<router-link to="/wms/inventory/transfertoline">
                        <base-button size="md" type="neutral">เบิกสินค้าสำหรับแพ็ค</base-button>
                    </router-link>
                    <router-link to="/backoffice/packings">
                        <base-button size="md" type="neutral" class="ml-2">{{
                            $t("back")
                        }}</base-button>
                    </router-link>
                </div>
            </div>
        </base-header>

        <div class="row">
            <div class="container-fluid mt--6 col-lg-4">
                <div>
                    <card
                        header-classes="bg-transparent"
                        footer-classes="bg-transparent"
                        body-classes="px-lg-4 py-lg-4"
                        class=" border-0  mb-4"
                    >
                        <template slot="header">
                            <!-- Select storage_id , shipping -->
                            <div class="form-group row">
                                <div class="col-md-6">
                                    <base-input
                                        :label="$t('wms.menu.inventory')"
                                    >
                                        <el-select
                                            v-model="params.storage_id"
                                            :label="$t('wms.menu.inventory')"
                                            :disabled="lock"
                                        >
                                            <el-option
                                                v-for="option in StorageTable"
                                                :key="option.ID"
                                                :label="option.Name"
                                                :value="option.ID"
                                            >
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </div>

                                <!-- <div class="col-md-6">
									<base-input :label="$t('shipping_provider')" >
										<el-select v-model=" params.shipping_provider_id " :label="$t('shipping_provider')"  :disabled="lock">
											<el-option v-for="option in ShippingProviderTable" :key="option.id" :label="option.name" :value="option.id" > </el-option>
										</el-select>
									</base-input>
								</div> -->

                                <div class="col-md-6">
                                    <base-input :label="$t('platform')">
                                        <el-select
                                            v-model="params.platform_id"
                                            :label="$t('platform')"
                                            :disabled="lock"
                                        >
                                            <el-option
                                                v-for="option in PlatformTable"
                                                :key="option.id"
                                                :label="option.name"
                                                :value="option.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </div>

                                <!-- Lock -->
                                <div class="col-md-3 py-4">
                                    <base-button
                                        @click="handleUnLock"
                                        v-if="lock"
                                        >UnLock</base-button
                                    >

                                    <!-- Unlock -->
                                    <base-button
                                        @click="handleLock"
                                        v-if="!lock"
                                        >Lock</base-button
                                    >
                                </div>
                            </div>
                        </template>

                        <div class="row" v-if="lock">
                            <div class="col-md-12">
                                <base-input
                                    :placeholder="$t('scanbarcode')"
                                    v-model="barcode"
                                    class="form-control-alternative"
                                    prepend-icon="ni ni-zoom-split-in"
                                    v-on:keyup.enter="handleBarcode"
                                ></base-input>
                            </div>
                            <div class="col-md-12" v-if="isWait">
                                <span>
                                    <i class="fas fa-spinner fa-spin"></i>
                                    กำลังประมวลผล...</span
                                >
                            </div>
                        </div>

                        <!-- Show Order ID -->
                    </card>
                </div>
            </div>

            <div class="container-fluid mt--6 col-lg-8">
                <div>
                    <!-- card right -->
                    <card
                        class="no-border-card"
                        body-classes="px-0 pb-1"
                        footer-classes="pb-2"
                    >
                        <template slot="header">
                            <div class="row">
                                <label
                                    class="col-md-12 col-form-label form-control-label"
                                >
                                    <h3
                                        class="mb-0"
                                        v-if="params.id == '' || params.id == 0"
                                    >
                                        {{ $t("order_information") }}
                                    </h3>
                                    <h3 class="mb-0" v-else>
                                        {{ $t("order_information") }} :
                                        {{ this.params.id }}

										<template v-if="params.tracking_number != ''">
											- Tracking Number : {{ this.params.tracking_number }}
										</template>
                                    </h3>
                                </label>
                            </div>
                        </template>
                        <!-- Selected Product -->
                        <div class="row">
                            <div
                                class="col-lg-3"
                                v-for="o in order_items"
                                :key="o.id"
                            >
                                <div class="card">
                                    <img
                                        class="card-img-top"
                                        :src="GetProductImage(o.wms_product_id)"
                                        style="max-height:150px; width:150px;margin-left: auto; margin-right: auto;"
                                    />
                                    <div class="card-body">
                                        <h3>
                                            <span
                                                class="text-green"
                                                v-if="o.pickup_need == null"
                                            >
                                                {{ o.wms_product_name }}
                                            </span>
                                            <span v-else>
                                                {{ o.wms_product_name }}
                                            </span>
                                            (
                                            <span
                                                class="text-green"
                                                v-if="o.pickup_need == null"
                                                >{{
                                                    o.pickup_need == null
                                                        ? o.pickup_quantity
                                                        : o.pickup_quantity -
                                                          o.pickup_need
                                                }}
                                                / {{ o.pickup_quantity }}
                                            </span>
                                            <span v-else
                                                >{{
                                                    o.pickup_need == null
                                                        ? o.pickup_quantity
                                                        : o.pickup_quantity -
                                                          o.pickup_need
                                                }}
                                                / {{ o.pickup_quantity }}
                                            </span>
                                            )
                                        </h3>

                                        <div
                                            class="col-md-12 text-green"
                                            v-if="o.pickup_need == null"
                                        >
                                            {{ o.barcode }}
                                        </div>
                                        <div class="col-md-12" v-else>
                                            {{ o.barcode }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>

        <!--  Modal -->
        <modal :show.sync="showModal" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
                Loading...
            </form>

            <template slot="footer"> </template>
        </modal>

		<modal :show.sync="showSyncModal" modal-classes="modal-secondary">
			<validation-observer ref="formValidator" >

            <form class="new-event--form" @submit.prevent="saveEvent">
                <base-input :label="$t('platform_order_id')" :name="$t('platform_order_id')" v-model="platform_order_id" rules="required"> </base-input>
            </form>
			</validation-observer>

            <template slot="footer">
                <button
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="handlePlatformSync()"
                >
                    Sync
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showSyncModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import FileInput from "@/components/Inputs/FileInput";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        FileInput,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            StorageTableOrg: "WmsStorage/getData",
            ProductTable: "WmsProduct/getData",
            PlatformTable: "Order/getPlatformTable"
        }),

        StorageTable() {
            return this.StorageTableOrg.filter(item => {
                return item.ID != 1;
            });
        }
    },
    data() {
        return {
            isLoading: false,
            showModal: false,
            lock: false,
            isWait: false,
            ShippingProviderTable: [
                { id: 1, name: "ไปรษณีย์ไทย" },
                { id: 2, name: "เคอรี่ เอ็กซ์เพรส" },
                { id: 3, name: "นินจาแวน" },
                { id: 4, name: "แฟลช เอ็กซ์เพรส" },
                { id: 5, name: "มาดามฟิน เอ็กซ์เพรส" }
            ],

            state: 0,
            barcode: "",
            first_barcode: "",
            pickup_items: [], // สินค้าที่หยิบใส่กล่องแล้ว
            order_items: [], // สินค้าที่เลือกจาก Order

            params: {
                id: 7,
                shipping_provider_id: 0,
                tracking_number: "",
                storage_id: "",
                barcode: "",
                platform_id: 1
            },

			showSyncModal: false,
			platform_order_id:"",

            propsToSearch: []
        };
    },
    mounted() {
        this.listStorage();
        this.listProduct();
        this.clearParam();
    },
    methods: {
        ...mapActions({
            listSaleChannel: "SaleChannel/listData",
            listStorage: "WmsStorage/listData",
            listProduct: "WmsProduct/listData",
            addItem: "Packing/addPickupItem",
            removeItem: "Packing/removePickupItem",
            closeOrder: "Packing/closeShippingOrder",
			syncPlatformOrder : "Order/syncPlatformOrder"
        }),

		handlePlatformSyncInit(){
			this.showSyncModal = true
			this.platform_order_id = ""
			this.$refs.formValidator.reset();
		},
		async handlePlatformSync(){

			let valid = await this.$refs.formValidator.validate();
            if (!valid) return;

			let params = {
				platform_id: this.params.platform_id,
				platform_order_id: this.platform_order_id
			}
			this.showSyncModal = false
			this.syncPlatformOrder(params).then(resp=>{
				swal.fire({
					title: "Sync ข้อมูลสำเร็จ",
					text: resp.data.Datum,
					icon: "success",
					confirmButtonClass: "btn btn-success btn-fill",
					buttonsStyling: false
				});

			}).catch((err)=>{
				swal.fire({
					title: err.response.data.Cause,
					text: "",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
			})

		},
        async handleBarcode() {
            console.log("handleBarcode", this.barcode);
            console.log("state", this.state);
            this.showModal = true;

            this.params.barcode = this.barcode;
            this.barcode = "";

            let isOrder = this.params.barcode.startsWith("MDF");
            let orderId = this.params.barcode.replace("MDF", "");

            if (this.isWait) {
                console.log("isLoading... , cancel this barcode");
                return;
            }

            // Fetch Order ID
            try {
                orderId = parseInt(orderId);
            } catch (error) {
                console.log("error", error);
                this.showModal = false;
                swal.fire({
                    title: error,
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }
            console.log("isOrder", isOrder);


            switch (this.state) {
                case 0: // Unknown Order
                    this.handleOpenByIDOrTracking(isOrder, orderId);
                    break;
                case 1: // Received orderId => เพิ่มสินค้า
                    if (isOrder) {
                        this.params.id = orderId;
                    } else {
                        let barcodeValid = this.isValidBarcode(); // Barcode สินค้า
                        if (!barcodeValid) {
                            // if (this.params.platform_id != 1) { // barcode ไม่ใช่สินค้า และเป็น platform อื่น ๆ
							this.handleOpenByIDOrTracking(isOrder, orderId);
                            // } else {
							// 	this.showModal = false;
							// 	swal.fire({
							// 		title: "ไม่พบสินค้าหรือรายการสั่งซื้อในในระบบ",
							// 		text: "",
							// 		icon: "error",
							// 		confirmButtonClass: "btn btn-danger btn-fill",
							// 		buttonsStyling: false
							// 	});
							// }
                            return;
                        } else {
                            // Product valid but not in order
                            let productValid = this.isValidProduct();
                            if (!productValid) {
                                this.showModal = false;
                                swal.fire({
                                    title: "สินค้าไม่ถูกต้อง",
                                    text: "",
                                    icon: "error",
                                    confirmButtonClass:
                                        "btn btn-danger btn-fill",
                                    buttonsStyling: false
                                });
                                return;
                            }
                        }
                    }

                    this.handleAdd(isOrder);

                    break;

                case 2: // สินค้าครบแล้ว ครบแล้ว

					//  Platform
					if (this.params.platform_id != 1) {
						// check bar code = firstbarcode
						if (this.first_barcode == this.params.barcode) {
							console.log("handle close platform",this.first_barcode , this.params.barcode)
							this.params.tracking_number = this.params.barcode
							this.state = 3
							this.showModal = false;
							console.log("State 2 Recived Tracking Number" )
							return;
						} else {
							// check is product
							let barcodeValid = this.isValidBarcode(); // Barcode สินค้า
       		                if (barcodeValid) {
								this.showModal = false;
								swal.fire({
									title: "สินค้าถูกเพิ่มครบแล้ว",
									text: "",
									icon: "error",
									confirmButtonClass: "btn btn-danger btn-fill",
									buttonsStyling: false
								});
								return;
							}

							console.log("State 2 handleOpenByIDOrTracking" )
							this.handleOpenByIDOrTracking(isOrder, orderId);



						}
					} else {
						// Madamefin
						if (isOrder) {
							this.handleOpenByID(orderId);
							return;
						}

						this.showModal = false;
						// Check is product barcode
						let barcodeValid = this.isValidBarcode();
						if (barcodeValid) {
							swal.fire({
								title: "กรุณาระบุ Tracking No.",
								text: "",
								icon: "error",
								confirmButtonClass: "btn btn-danger btn-fill",
								buttonsStyling: false
							});
							return;
						}

						// Check Tracking valid
						let tName = "";
						var regIsThaipost = /^[A-Z]{2}\d{9}[A-Z]{2}$/gi;
						var regIsKerry = /^[A-Z]{4}\d{9}$/gi;
						var regIsKerryMFIN = /^MFIN[0-9A-F]{10}$/gi;
						var regIsKerryLazada = /^[A-Z]{5}\d{10}$/gi;
						var regIsKerryShopee = /^SD[A-Z]{2}\d{10}$/gi;
						var regIsDHL = /^[A-Z]{5}\d{10}$/gi;
						var regIsFlash = /^TH[0-9A-Z]{12,13}$/gi;
						var regIsJT = /^[0-9]{12}$/gi;
						var regIsSPX = /^SPX[0-9A-Z]{12,14}$/gi;
					
						if (regIsThaipost.test(this.params.barcode)) {
							tName = "ไปรษณีย์ไทย";
						} else if (regIsKerry.test(this.params.barcode)) {
							tName = "Kerry";
						} else if (regIsKerryMFIN.test(this.params.barcode)) {
							tName = "Kerry";
						} else if (regIsKerryLazada.test(this.params.barcode)) {
							tName = "Kerry";
						} else if (regIsKerryShopee.test(this.params.barcode)) {
							tName = "Kerry";
						} else if (regIsDHL.test(this.params.barcode)) {
							tName = "DHL";
						} else if (regIsFlash.test(this.params.barcode)) {
							tName = "Flash";
						} else if (regIsJT.test(this.params.barcode)) {
							tName = "J&T";
						} else if (regIsSPX.test(this.params.barcode)) {
							tName = "SPX";
						} else if (this.params.platform_id == 1) {
							swal.fire({
								title: "หมายเลข Tracking ไม่ถูกต้อง",
								text: "",
								icon: "error",
								confirmButtonClass: "btn btn-danger btn-fill",
								buttonsStyling: false
							});
							return;
						}

						if (tName != "") { // Platform
							this.state = 3
							this.params.tracking_number = this.params.barcode
							console.log("State 2 Recived Tracking Number" )
						} else {
							swal.fire({
								title:
									"ยืนยันการจัดส่งสินค้า Order No." +
									this.params.id +
									" หรือไม่ ?",
								text: "Tracking No. " + this.params.barcode + `  (${tName})`,
								icon: "info",
								showCancelButton: true,
								confirmButtonClass: "btn btn-success btn-fill",
								cancelButtonClass: "btn btn-danger btn-fill",
								confirmButtonText: this.$t("confirm"),
								cancelButtonText: this.$t("cancel"),
								buttonsStyling: false
							}).then(result => {
								if (result.value) {
									let data = {
										id: this.params.id,
										shipping_provider_id: 0,
										//shipping_provider_id: this.params.shipping_provider_id,
										tracking_number: this.params.barcode
									};

									this.isWait = true;
									this.closeOrder(data)
										.then(resp => {
											swal.fire({
												title: "Success",
												text:
													"Order No." +
													this.params.id +
													" จัดส่งสำเร็จ",
												icon: "success",
												confirmButtonClass: "btn btn-success btn-fill",
												buttonsStyling: false
											});
											this.clearParam();
											this.isWait = false;
										})
										.catch(err => {
											this.isWait = false;
											swal.fire({
												title: "Error",
												text: err.response.data.Cause,
												icon: "error",
												confirmButtonClass: "btn btn-danger btn-fill",
												buttonsStyling: false
											});
										});
								}
							})
						}

					}
                    break;
				case 3: // Received Tracking Number
					if (isOrder) {
						this.handleOpenByID(orderId);
						return;
					}

					this.showModal = false;

					if (this.params.barcode != "CLOSEORDERMDF")
					{
						swal.fire({
							title: "กรุณาระบุ Barcode ปิดการแพ็คสินค้า",
							text: "",
							icon: "error",
							confirmButtonClass: "btn btn-danger btn-fill",
							buttonsStyling: false
						});
						return;
					}

					console.log("State 3 Recived 'CLOSEORDERMDF'" )
					this.handleClose();
				break;
            }
        },

        async handleOpenByIDOrTracking(isOrder, orderId) {

            let resp = {};
			this.isWait = true;
			try {
				resp = await this.addItem({
					id: isOrder ? orderId : 0,
					storage_id: this.params.storage_id,
					barcode: isOrder ? "" : this.params.barcode, 
					platform_id: this.params.platform_id
				});
				this.isWait = false;
			} catch (err) {
				console.log(err);
				this.showModal = false;
				this.isWait = false;

				if ( err.response.data.Cause == "InventoryGetIDByProductIDStorageID, record not found") 
				{
					swal.fire({
						title: this.$t(err.response.data.Msg),
						text: "ไม่พบสินค้าในคลัง",
						icon: "error",
						confirmButtonClass: "btn btn-danger btn-fill",
						buttonsStyling: false
					});
					return false;
				}

				swal.fire({
					title: this.$t(err.response.data.Msg),
					text: err.response.data.Cause,
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});

				return false;
			}

			// Check Product availabel all
			if (resp.data.Datum.all_available == false) {
				let product = "";
				resp.data.Datum.order_items.forEach(e => {
					if (e.available == false) {
						if (product == "") {
							product = e.wms_product_name;
						} else {
							product = "," + e.wms_product_name;
						}
					}
				});

				swal.fire({
					title: this.$t("errors.inventory_not_found"),
					text: product,
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});

				return true;
			}

			this.pickup_items = resp.data.Datum.pickup_items;
			this.order_items = resp.data.Datum.order_items;

			this.first_barcode = this.params.barcode
			if (isOrder) {
				this.params.id = orderId;
			} else {
				this.params.id = resp.data.Datum.id;
			}

			if (this.isOrderSuccess()) {
				this.state = 2;
			} else {
				this.state = 1;
			}
			this.barcode = "";
			this.showModal = false;
           
        },


        async handleOpenByID(orderId) {
            this.isWait = true;
            let resp = {};
            try {
                resp = await this.addItem({
                    id: orderId,
                    storage_id: this.params.storage_id,
                    barcode: ""
                });
                this.isWait = false;
            } catch (err) {
                console.log(err);
                this.showModal = false;
                this.isWait = false;
                swal.fire({
                    title: this.$t(err.response.data.Msg),
                    text: err.response.data.Cause,
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });

                return;
            }

            if (resp.data.Datum.all_available == false) {
                let product = "";
                resp.data.Datum.order_items.forEach(e => {
                    if (e.available == false) {
                        if (product == "") {
                            product = e.wms_product_name;
                        } else {
                            product = "," + e.wms_product_name;
                        }
                    }
                });

                swal.fire({
                    title: this.$t("errors.inventory_not_found"),
                    text: product,
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });

                return;
            }

            this.pickup_items = resp.data.Datum.pickup_items;
            this.order_items = resp.data.Datum.order_items;
            this.params.id = orderId;

            if (this.isOrderSuccess()) {
                this.state = 2;
            } else {
                this.state = 1;
            }

			this.params.tracking_number = ""
            this.showModal = false;
        },
        handleClose() {

			let data = {
				id: this.params.id,
				shipping_provider_id: 0,
				tracking_number: this.params.tracking_number
			};

			this.isWait = true;
			this.closeOrder(data)
			.then(resp => {
				swal.fire({
					title: "Success",
					text:
						"Order No." +
						this.params.id +
						" จัดส่งสำเร็จ",
					icon: "success",
					confirmButtonClass: "btn btn-success btn-fill",
					buttonsStyling: false
				});
				this.clearParam();
				this.isWait = false;
			})
			.catch(err => {
				this.isWait = false;
				swal.fire({
					title: "Error",
					text: err.response.data.Cause,
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
			});


			/*		
            this.showModal = false;
            let barcodeValid = this.isValidBarcode();
            if (barcodeValid) {
                this.showModal = false;
                swal.fire({
                    title: "กรุณาระบุ Tracking No.",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }

            let tName = "";
            var regIsThaipost = /^[A-Z]{2}\d{9}[A-Z]{2}$/gi;
            var regIsKerry = /^[A-Z]{4}\d{9}$/gi;
            var regIsKerryLazada = /^[A-Z]{5}\d{10}$/gi;
            var regIsKerryShopee = /^SD[A-Z]{2}\d{10}$/gi;
            var regIsDHL = /^[A-Z]{5}\d{10}$/gi;
		
            if (regIsThaipost.test(this.params.barcode)) {
                tName = "ไปรษณีย์ไทย";
            } else if (regIsKerry.test(this.params.barcode)) {
                tName = "Kerry";
            } else if (regIsKerryLazada.test(this.params.barcode)) {
                tName = "Kerry";
            } else if (regIsKerryShopee.test(this.params.barcode)) {
                tName = "Kerry";
            } else if (regIsDHL.test(this.params.barcode)) {
                tName = "DHL";
            } else if (this.params.platform_id == 1) {
                swal.fire({
                    title: "หมายเลข Tracking ไม่ถูกต้อง",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }

            swal.fire({
                title:
                    "ยืนยันการจัดส่งสินค้า Order No." +
                    this.params.id +
                    " หรือไม่ ?",
                text: "Tracking No. " + this.params.barcode + `  (${tName})`,
                icon: "info",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    let data = {
                        id: this.params.id,
                        shipping_provider_id: 0,
                        //shipping_provider_id: this.params.shipping_provider_id,
                        tracking_number: this.params.barcode
                    };

                    this.isWait = true;
                    this.closeOrder(data)
                        .then(resp => {
                            swal.fire({
                                title: "Success",
                                text:
                                    "Order No." +
                                    this.params.id +
                                    " จัดส่งสำเร็จ",
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                            this.clearParam();
                            this.isWait = false;
                        })
                        .catch(err => {
                            this.isWait = false;
                            swal.fire({
                                title: "Error",
                                text: err.response.data.Cause,
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });
                }
            });
			*/
        },
		handleConfirmClose() {

		},
        async handleAdd(isOrder) {
            this.isWait = true;
			let resp = {};
            try {
                resp = await this.addItem({
                    id: this.params.id,
                    storage_id: this.params.storage_id,
                    barcode: isOrder ? "" : this.params.barcode,
                    platform_id: this.params.platform_id
                });
                this.isWait = false;
            } catch (err) {
                console.log(err);
                this.showModal = false;
                swal.fire({
                    title: this.$t(err.response.data.Msg),
                    text: err.response.data.Cause,
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });

                if (isOrder) {
                    this.clearParam();
                }
                this.isWait = false;
                return;
            }

            if (resp.data.Datum.all_available == false) {
                let product = "";
                resp.data.Datum.order_items.forEach(e => {
                    if (e.available == false) {
                        if (product == "") {
                            product = e.wms_product_name;
                        } else {
                            product = "," + e.wms_product_name;
                        }
                    }
                });

                swal.fire({
                    title: this.$t("errors.inventory_not_found"),
                    text: product,
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });

                return;
            }

            this.pickup_items = resp.data.Datum.pickup_items;
            this.order_items = resp.data.Datum.order_items;

            if (this.isOrderSuccess()) {
                this.state = 2;
            } else {
                this.state = 1;
            }
            this.barcode = "";
            this.showModal = false;
        },

        isValidBarcode() {
            let isValid = false;
            if (this.params.barcode == "") {
                isValid = false;
            }

            this.ProductTable.forEach(item => {
                if (item.BarCode == this.params.barcode) {
                    isValid = true;
                }
            });
            return isValid;
        },
        isValidProduct() {
            let isValid = false;
            if (this.params.barcode == "") {
                isValid = false;
            }

            this.order_items.forEach(item => {
                if (item.barcode == this.params.barcode) {
                    isValid = true;
                }
            });
            return isValid;
        },
        isOrderSuccess() {
            let isPickupSuccess = true;
            this.order_items.forEach(item => {
                if (item.pickup_need != null) {
                    isPickupSuccess = false;
                }
            });
            return isPickupSuccess;
        },
        handleLock() {
            //  check storage sleected
            if (this.params.storage_id == "") {
                swal.fire({
                    title: "Error",
                    text: "กรุณาเลือกคลังสินค้า",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }

            // check shipping provider
            //if(this.params.shipping_provider_id == ""){
            //	swal.fire({
            //		title: "Error",
            //		text: "กรุณาเลือกผู้จัดส่ง",
            //		icon: "error",
            //		confirmButtonClass: "btn btn-danger btn-fill",
            //		buttonsStyling: false
            //	});
            //	return;
            //}

            this.lock = true;
            this.clearParam();
        },
        handleUnLock() {
            this.lock = false;
            this.clearParam();
        },
        clearParam() {
            this.order_items = [];
            this.pickup_items = [];
            this.params.id = "";
            this.params.tracking_number = "";
            this.params.barcode = "";
            this.barcode = "";
            this.state = 0;
        },
        GetProductImage(id) {
            // find product table
            let product = this.ProductTable.find(x => x.ID == id);
            if (product) {
                return (
                    process.env.VUE_APP_API_BASE_URL +
                    "/files/wms/" +
                    product.Image
                );
            } else {
                return "";
            }
        }
    }
};
</script>

<style scoped>
.el-table td {
    padding: 0 !important;
}
</style>
